const industries = [
  { value: "Information Technology", label: "Information Technology (IT)" },
  // { value: "Healthcare", label: "Healthcare" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "Drug Store", label: "Drug Store" },
  { value: "Perfume Industry", label: "Perfume Industry" },
  { value: "Finance", label: "Finance" },
  { value: "Consumer Goods", label: "Consumer Goods" },
  { value: "Retail", label: "Retail" },
  { value: "Energy", label: "Energy" },
  { value: "Telecommunications", label: "Telecommunications" },
  {
    value: "Transportation and Logistics",
    label: "Transportation and Logistics",
  },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Automotive", label: "Automotive" },
  { value: "Media and Entertainment", label: "Media and Entertainment" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Construction", label: "Construction" },
  { value: "Education", label: "Education" },
  { value: "Hospitality and Tourism", label: "Hospitality and Tourism" },
  { value: "Aerospace and Defense", label: "Aerospace and Defense" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Chemicals", label: "Chemicals" },
  { value: "Legal Services", label: "Legal Services" },
  {
    value: "Nonprofit and Social Services",
    label: "Nonprofit and Social Services",
  },
  { value: "Others", label: "Others" },
];

const days =[
  {label:"Sunday",
    value:0
  },
  {label:"Monday",
    value:1
  },
  {label:"Tuesday",
    value:2
  },
  {label:"Wednesday",
    value:3
  },
  {label:"Thursday",
    value:4
  },
  {label:"Friday",
    value:5
  },
  {label:"Saturday",
    value:6
  },
]

const getIndustries = () => {
  return industries;
};

const getDays = () => {
  return days;
};
const getDaysByValues = (values) => {

  return days
    .filter((day) => values.includes(day.value))
    .map((day) => day.label)
    .join(", ");
};

export { getIndustries, getDays,getDaysByValues };
